/* eslint-disable no-unused-vars */

import React, { useState, useRef, useCallback, useMemo } from 'react'
import { Drawer } from 'rsuite'
import { Tab, Tabs } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import jwtDecode from 'jwt-decode'
import { LOGIN } from '../../../../../store/actions'
import { getDataService } from '../../../../../services/back-end-service'
import { setLocalStorage } from '../../../../../utils/localStorage'
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../../../../utils/constants'
import { onError, onSuccess } from '../../../../../utils/CommonMethods'
import { BoUrl } from '../../../../../services/BO-path-url'
import useAuth from '../../../../../hooks/useAuth'
import CPIDataGridFiche from '../../../../../components/DataGrid/CPIDataGridFiche'

function UserAccessList({
  listOpen,
  closed,
  UserMetierAccess,
  UserAdminAccess,
  hideDrawer,
}) {
  const history = useHistory()
  const [initLoader, setInitLoader] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const { dispatch } = useAuth()
  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation()
  const filterValue = [
    {
      name: 'login',
      operator: 'contains',
      type: 'string',
      value: '',
    },
    {
      name: 'client_group',
      operator: 'contains',
      type: 'string',
      value: '',
    },
  ]

  let listClass = ['header-user-list']
  if (listOpen) {
    listClass = [...listClass, 'open']
  }

  const onErrorLog = (e) => {
    setInitLoader(false)
    onError(e)
  }

  const onSuccessLogAdmin = (response) => {
    onSuccess(response)
    setInitLoader(false)
    setLocalStorage('super_admin', 'super_admin')
    setLocalStorage(ACCESS_TOKEN, response.info_log.accesstoken)
    setLocalStorage('ACCESS_TOKEN_BO', response.info_log.accesstoken)
    setLocalStorage(REFRESH_TOKEN, response.info_log.refreshtoken)
    setInitLoader(false)
    const decodedToken = jwtDecode(response?.info_log?.accesstoken)
    setLocalStorage('appname', decodedToken?.iss)
    setLocalStorage('customername', decodedToken?.customer)
    // const boMenu = Object.values(response.menu_bo.admin)
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: true,
        menu: response.menu.items,
        admin: [],
        entity: response.menu.entity,
        scope: response.menu.scope,
        client_access: response.menu_bo?.client_access || {},
      },
    })
    setLocalStorage('AdminMenu', [])
    setLocalStorage('menu', JSON.stringify(response.menu.items))
    history.push('/dashboard')
  }

  const onSuccessLogClient = (response) => {
    onSuccess(response)
    setInitLoader(false)
    const decodedToken = jwtDecode(response?.info_log?.accesstoken)
    setLocalStorage(ACCESS_TOKEN, response.info_log.accesstoken)
    setLocalStorage(REFRESH_TOKEN, response.info_log.refreshtoken)
    setLocalStorage('super_admin', 'super_admin')
    setLocalStorage('ACCESS_TOKEN_BO', response.info_log.accesstoken)
    setLocalStorage('appname', decodedToken?.iss)
    setLocalStorage('customername', decodedToken?.customer)
    const userMenu = Object.values(response.menu.admin)
    const unicMenu = [...userMenu]
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: true,
        menu: response.menu.items,
        admin: unicMenu,
        entity: response.menu.entity,
        scope: response.menu.scope,
        client_access: {},
      },
    })
    setLocalStorage('AdminMenu', JSON.stringify(unicMenu))
    history.push('/dashboard')
  }

  const loginAdminPage = useCallback(
    async (id) => {
      setInitLoader(true)
      hideDrawer()
      await getDataService(
        `${BoUrl.loginPageClient.login}${id}`,
        onSuccessLogAdmin,
        onErrorLog
      )
    },
    [initLoader]
  )
  const loginClientPage = useCallback(
    async (id) => {
      setInitLoader(true)
      hideDrawer()
      await getDataService(
        `${BoUrl.loginPageClient.getMenuLogas}${id}`,
        onSuccessLogClient,
        onErrorLog
      )
    },
    [initLoader]
  )

  const columns_LogAs = useMemo(
    () => [
      {
        name: 'login',
        header: t('composant.modal_select_filiale.code'),
        minWidth: 150,
        defaultFlex: 1,
        render: ({ data, value }) => (
          <Link
            onClick={() => loginAdminPage(data.user_id)}
            style={{ color: 'Black', fontSize: '12px', textDecoration: 'none' }}
          >
            {value}
          </Link>
        ),
      },
      {
        name: 'client_group',
        header: t('composant.modal_select_filiale.nom'),
        minWidth: 100,
        defaultFlex: 1,
      },
    ],
    [t]
  )

  const columns_metier = useMemo(
    () => [
      {
        name: 'code',
        header: t('composant.modal_select_filiale.code'),
        minWidth: 150,
        defaultFlex: 1,
        render: ({ data, value }) => (
          <Link
            onClick={() => loginClientPage(data.id)}
            style={{ color: 'Black', fontSize: '12px', textDecoration: 'none' }}
          >
            {value}
          </Link>
        ),
      },
      {
        name: 'name',
        header: t('composant.modal_select_filiale.nom'),
        minWidth: 100,
        defaultFlex: 1,
      },
    ],
    [t]
  )

  const cardBody = (
    <Tabs variant="pills" style={{ paddingBottom: '0px !imprtant' }}>
      {UserMetierAccess && UserMetierAccess.length && (
        <Tab
          eventKey="metier"
          title={t('listUserAdminDispo')}
          style={{ height: 'calc(100vh - 200px)' }}
        >
          <CPIDataGridFiche
            idProperty="id"
            emptyText={t('NoData')}
            columns={columns_metier}
            dataSource={UserMetierAccess}
            pagination={false}
            defaultFilterValue={filterValue}
          />
        </Tab>
      )}
      <Tab
        eventKey="admin"
        title={t('listUserClientDispo')}
        style={{ height: 'calc(100vh - 200px)' }}
      >
        <CPIDataGridFiche
          idProperty="id"
          emptyText={t('NoData')}
          columns={columns_LogAs}
          dataSource={UserAdminAccess}
          pagination={false}
          defaultFilterValue={filterValue}
        />
      </Tab>
    </Tabs>
  )
  return (
    <>
      <Drawer size="sm" placement="right" open={listOpen} onClose={closed}>
        <Drawer.Header>
          <Drawer.Title>{t('AdminChange')}</Drawer.Title>
        </Drawer.Header>
        {cardBody}
      </Drawer>
      {initLoader && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            marginRight: 10,
          }}
        >
          <div
            style={{
              animation: '400ms linear infinite anim-rotate',
              borderBottom: '2px solid transparent',
              borderLeft: '2px solid #fff',
              borderRadius: '50%',
              borderRight: '2px solid transparent',
              borderTop: '2px solid #fff',
              boxSizing: 'border-box',
              height: 20,
              width: 20,
              marginLeft: '50%',
              marginRight: '50%',
              display: 'block',
            }}
          />
        </div>
      )}
    </>
  )
}

export default UserAccessList

